import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]

import MomentJVM from "../moment/MomentJVM.vue";
import Decoration from "../decoration/Decoration.vue";
import { IEpoch } from "../../interfaces/IEpoch";


export default /*@__PURE__*/_defineComponent({
  __name: 'EpochJVM',
  props: {
    epoch: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    id: __props.epoch.epochType,
    class: _normalizeClass(['epoch', __props.epoch.epochType])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.epoch?.timelineMapItems, (item) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (item.type=='Moment')
          ? (_openBlock(), _createBlock(MomentJVM, {
              key: item.urlSegment,
              moment: item
            }, null, 8 /* PROPS */, ["moment"]))
          : (_openBlock(), _createBlock(Decoration, {
              key: 1,
              decoration: item
            }, null, 8 /* PROPS */, ["decoration"]))
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}
}

})